<template>
  <!-- 创建录入信息 -->
  <div class="add-group-wrapper">
    <el-dialog
        :visible.sync="isShow"
        width="500px"
        :title="player.length>0 ? '编辑已转会球员信息' : '创建已转会球员信息'"
        :close-on-click-modal="false"
        custom-class="add-sup-group"
    >
      <div class="scroll-wrapper">
        <vue-scroll :ops="ops">
          <div class="form-wrapper">
            <el-form
                v-if="!loading"
                ref="addTransferPlayer"
                :model="transferPlayerForm"
                :rules="formRules"
                label-width="110px"
            >

              <fieldset class="vita-form-fieldset">
                <legend>已转会球员信息</legend>
                <el-row v-for="(item, index) in transferPlayerForm.transferPlayerList" :key="index"
                        style="display: flex;border-bottom:1px solid #dcdfe6;margin-block:10px">
                  <div>
                    <el-form-item
                        :label="`球员姓名${index + 1}`"
                        :prop="`transferPlayerList.${index}.idName`"
                        :rules="[{ required: true, message: '信息不能为空', trigger: 'blur' }]"
                    >
                      <el-input
                          v-model="item.idName"
                          placeholder="请输入球员姓名"
                          class="yioks-w75"
                      ></el-input>

                    </el-form-item>

                    <el-form-item
                        :label="`证件类型${index + 1}`"
                        :prop="`transferPlayerList.${index}.idType`"
                        :rules="[{ required: true, message: '信息不能为空', trigger: 'change' }]"
                    >
                      <el-select
                          v-model="item.idType"
                          placeholder="请选择证件类型"
                          class="yioks-w75">
                        <el-option
                            v-for="(item,id) in id_types"
                            :key="id"
                            :label="item.key"
                            :value="item.value"/>
                      </el-select>

                    </el-form-item>

                    <el-form-item
                        :label="`身份证号${index + 1}`"
                        :prop="`transferPlayerList.${index}.idNumber`"
                        :rules="{required: true, validator: (rule, value, callback) => {validateNumberId(rule, value, callback, index, item.idType)}, trigger: 'blur'}"
                    >
                      <el-input
                          v-model="item.idNumber"
                          placeholder="请输入身份证号"
                          class="yioks-w75"
                      ></el-input>

                    </el-form-item>

                    <el-form-item
                        :label="`球员位置${index + 1}`"
                        :prop="`transferPlayerList.${index}.position`"
                        :rules="[{ required: true, message: '信息不能为空', trigger: 'change' }]"
                    >
                      <el-select
                          v-model="item.position"
                          multiple
                          placeholder="请选择球员位置"
                          class="yioks-w75">
                        <el-option
                            v-for="(item,ind) in playerOption"
                            :key="ind"
                            :label="item.playerPositionName"
                            :value="item.playerPositionName"/>
                      </el-select>

                    </el-form-item>
                    <el-form-item label="上传转会证明（中国足协注册转会页面截图）" :prop="`transferPlayerList.${index}.documentUrl`"
                      :rules="[requiredItem('转会证明')]">
                      <el-upload
                        :action="uploadUrl"
                        :on-success="(res, file, fileList)=> fileUploadSuccessProve(res, file, fileList,index)"
                        :before-upload="(file) => fileUploadBeforeProve(file,index)"
                        :on-remove="(file, fileList) => fileRemoveProve(file,fileList,index)"
                        :on-exceed="
                            (file, fileList) =>
                              handleScoreDocUoloadCheck(file, fileList, index)
                          "
                        :limit="1"
                        :file-list="item.fileList">
                        <el-button size="small" type="primary" >点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpeg,jpg,png,pdf文件，且不超过20M</div>
                      </el-upload>
                    </el-form-item>
                  </div>
                  <div class="action-wrapper">
                    <div
                        v-if="transferPlayerForm.transferPlayerList.length - 1 === index"
                        class="action-icon add-icon"
                        @click="handleAddSquad"
                    >
                      <i class="el-icon-circle-plus-outline"></i>
                    </div>
                    <div
                        v-if="transferPlayerForm.transferPlayerList.length > 1"
                        class="action-icon delete-icon"
                        @click="handleDeleteSquad(index)"
                    >
                      <i class="el-icon-remove-outline"></i>
                    </div>
                  </div>
                </el-row>
              </fieldset>

            </el-form>
            <div v-if="!loading" class="tip">带 * 号的为必填项，点击加号或减号可添加或减少球员信息</div>
            <div v-if="!loading" class="dialog_btn_wrap">
              <el-button
                  type="primary"
                  style="margin-right:20px"
                  :loading="addbtnLoading"
                  @click="addTransferPlayer"
              >确认
              </el-button>
            </div>
            <yioks-loading v-if="loading" style="height: 500px"/>
          </div>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { id_types } from "@/utils/yioks_data";
import {ops} from "@/utils/scrollIndialog";
import player from "@/api/player";
import rulesMixin from "@/utils/formRules/player";
import rules from "@/utils/formRules/rules";
import { requiredItem } from '@/assets/js/formRules'

export default {
  name: "associatedSquadTransferPlayer",
  mixins: [rulesMixin],
  props: {
    isShowDialog: {
      type: Boolean,
      required: true,
    },
    player: {
      type: Array,
      required: false,
    }
  },

  computed: {
    isShow: {
      get() {
        return this.isShowDialog;
      },
      set(val) {
        this.$emit("hideTransferDialog", false,val );
      },
    },
  },

  data() {
    const validateNumberId = (rule, value, callback, index, key) => {
      if (key === 'IDNUMBER'){
        if (rules.idNumber(value)) {
          callback();
        } else callback(new Error("请输入有效的证件号"));
      }else{
        callback();
      }

    };
    return {
      validateNumberId,
      requiredItem,
      uploadUrl: '/api/zuxie/guozi/upload/uploadJixiaoFile',
      imageData:{image:''},
      ops,
      id_types,
      loading: false,
      addbtnLoading: false,
      transferPlayerForm: {
        transferPlayerList: [ // 球队组别
          {
            idName: "",
            idType: "IDNUMBER",
            idNumber: "",
            position: [], // 位置
            documentUrl: '', // 证明文件
            documentTitle: '', // 证明文件
            fileList:[],
          },
        ],
      },
      playerOption: [], //球员位置
      transferPlayerRules: {
      },
    };
  },


  created () {
    this.getAllPositionList();

    if(this.player.length>0){
      this.transferPlayerForm.transferPlayerList = [];
      console.log(this.player)
      this.player.map(item=>{
        var _item = {...item};
        _item.position = _item.position.split(",")
        this.transferPlayerForm.transferPlayerList.push(_item);
      })
    }
  },

  methods: {
    /* 文件上传成功 */
    fileUploadSuccessProve( res, file, fileList, index ) {
      let { transferPlayerList } = this.transferPlayerForm;
      transferPlayerList[index].documentUrl = res.url;
      transferPlayerList[index].documentTitle = res.fileName;
      this.$set(this.transferPlayerForm, 'transferPlayerList', transferPlayerList);
      console.log(this.transferPlayerForm.transferPlayerList);
      this.$refs.addTransferPlayer.clearValidate(`transferPlayerList.${index}.documentUrl`)
    },
    /* 文件上传校验 */
    fileUploadBeforeProve(file) {
      const isLt10M = file.size / 1024 / 1024 < 20;
      const reg = /\.(jpeg|jpg|png|pdf)$/i;   // 检验文件后缀名，
      const isEndRight = reg.test(file.name);
      const isEXCEL = isEndRight;
      if (!isLt10M) {
        this.$message.warning('上传文件不能大于20M')
      }
      if (!isEXCEL) {
        this.$message.warning('只允许上传png,jpeg,jpg,gif,pdf格式文件')
      }
      if(isLt10M && isEXCEL) {
        this.$set(this.imageData, 'image', file)
      }
      return isLt10M && isEXCEL
    },
  
    fileRemoveProve(file, fileList,index) {
      let { transferPlayerList } = this.transferPlayerForm;
      transferPlayerList[index].documentUrl = '';
      transferPlayerList[index].documentTitle = '';
      transferPlayerList[index].fileList = [];
      this.$set(this.transferPlayerForm, 'transferPlayerList', transferPlayerList);
    },
    handleScoreDocUoloadCheck(file, fileList, index) {
      this.$message.warning(`最多只能上传一个文件。如果您需要修改已上传文件，请先删除已上传的文件后再重新上传。`);
    },
    // 添加接口
    addTransferPlayer() {
      this.$refs['addTransferPlayer'].validate(valid => {
        if (valid) {
          this.addbtnLoading = true
          const { transferPlayerList } = this.transferPlayerForm;
          this.$emit('hideTransferDialog', true,transferPlayerList)

        }

      })
    },

    handleAddSquad() {
      const newSquad = {
        idName: "",
        idType: "IDNUMBER",
        idNumber: "",
        position: [], // 位置
        documentUrl: '', // 证明文件
        documentTitle: '', // 证明文件
        fileList:[],
      };
      const {transferPlayerList} = this.transferPlayerForm;
      transferPlayerList.push(newSquad);
      this.$set(this.transferPlayerForm, "transferPlayerList", transferPlayerList);
    },
    handleDeleteSquad(index) {
      const {transferPlayerList} = this.transferPlayerForm;
      transferPlayerList.splice(index, 1);
      this.$set(this.transferPlayerForm, "transferPlayerList", transferPlayerList);
    },
    // 获取球员位置
    getAllPositionList() {
      player.allPositionList().then((res) => {
        this.playerOption = res;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.scroll-wrapper
  height 400px

.form-wrapper
  margin-right 30px

.yioks-w100
  width 100%

.yioks-w75
  width 100%

.yioks-w76
  width 90%

.vita-form-fieldset
  padding 10px 10px 0
  border 1px dashed #dcdfe6
  margin-bottom 20px

.action-wrapper
  display flex
  margin-bottom 10px
  align-items center

  .action-icon
    width 25px
    display flex
    align-items center
    justify-content center
    border-radius 50%
    height 35px
    color $color_white
    font-size 2em
    margin 0 5px
    cursor pointer
    user-select none

    &.add-icon
      color $green_color

    &.delete-icon
      color $orange_color

.btns-group
  display flex
  justify-content center
  margin 30px 0
</style>

<style lang="stylus">
.add-sup-group
  .el-dialog__header
    border-bottom 1px solid #666
    margin 0 20px
    padding-left 0

    .el-dialog__title
      font-weight normal
      font-size 20px
      color #666
</style>
